import { Skeleton } from "@material-ui/lab";
import React from "react";

export const RectSkeleton: React.FC = () => {
    return <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
}
